// src/pages/RegistrationPage.tsx
import React, { useState } from "react";
import './style.scss';
import RegistrationHeader from "./components/RegistrationHeader";
import RegistrationSteps from "./components/RegistrationSteps";
import RegistrationForm from "./components/RegistrationForm";
import RegistrationBtnBack from "./components/RegistrationBtnBack";

import { ReactComponent as TopRightSVG } from 'assets/img/particules_top-right.svg';
import { ReactComponent as BottomLeftSVG } from 'assets/img/particules_bottom-left.svg';
import SuccessConfirmStep from "./components/SuccessConfirmStep";
import { useNavigate } from "react-router-dom";

const RegistrationFuitesDonneesPage = () => {

  const [steps, setSteps] = useState([
    { number: 1, label: 'Email', completed: true },
    { number: 2, label: 'Informations', completed: false, active: true },
    { number: 3, label: 'Confirmation', completed: false },
  ]);
  const [currentStep, setCurrentStep] = useState<number>(2); // Start at step 2 (Informations)
  const [globalEmail, setGlobalEmail] = useState<string | null>(null);

  const updateSteps = (stepNumber: number) => {
    const updatedSteps = steps.map(step => ({
      ...step,
      completed: step.number < stepNumber,
      active: step.number === stepNumber
    }));

    setSteps(updatedSteps);
    setCurrentStep(stepNumber);
  };

  return (
    <div className="registration-page">
      {/* Top right SVG background */}
      <div className="svg-background svg-background--top-right">
        <TopRightSVG />
      </div>

      {/* Bottom left SVG background */}
      <div className="svg-background svg-background--bottom-left">
        <BottomLeftSVG />
      </div>

      <RegistrationHeader />

      {currentStep === 3 ? (
        <SuccessConfirmStep
          email={globalEmail}
        />
      ) : (
        <>
          {/*<RegistrationBtnBack />*/}
          <div className="registration-container">
            <div className="registration-content">
              <RegistrationSteps steps={steps} />
              <RegistrationForm
                globalSetSteps={updateSteps}
                globalCurrentStep={currentStep}
                setGlobalEmail={setGlobalEmail}
                globalEmail={globalEmail}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RegistrationFuitesDonneesPage;